import { render, staticRenderFns } from "./capped-list.vue?vue&type=template&id=82a80abc&scoped=true&"
import script from "./capped-list.vue?vue&type=script&lang=js&"
export * from "./capped-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a80abc",
  null
  
)

export default component.exports